import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { ReportService } from 'src/app/services/report.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sp-request-count-report',
  templateUrl: './sp-request-count-report.component.html',
  styleUrls: ['./sp-request-count-report.component.scss']
})
export class SpRequestCountReportComponent implements OnInit {

    spRequestCountReportForm: FormGroup;
    toMinDate: Date;
    toMaxDate=new Date()
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    orderStatusList: any = []
    filteredList1: any = []
    serviceQueue: any = []

    constructor(
        private fb: FormBuilder,
        private reportService: ReportService,
    ) {
    }


    ngOnInit(): void {
        this.init()
    }
    init() {
        this.spRequestCountReportForm = this.fb.group({
            startDate: [null, Validators.required],
            endDate: [null, Validators.required],
        });
    }
    Reset() {
        this.spRequestCountReportForm.reset()
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.spRequestCountReportForm.controls["startDate"].value;
    }


    generateExcel() {
        debugger
        if (!this.spRequestCountReportForm.value.startDate && !this.spRequestCountReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
        }
        else if (!this.spRequestCountReportForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
        }
        else if (!this.spRequestCountReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
        }
        else if (this.spRequestCountReportForm.value.startDate > this.spRequestCountReportForm.value.endDate) {
            if (this.spRequestCountReportForm.value.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',
                })
            }
        }
        else {
            debugger
            var filterSearch:any = {};
            var start = moment(this.spRequestCountReportForm.value.startDate).format("YYYY/MM/DD");
            var end = moment(this.spRequestCountReportForm.value.endDate).format("YYYY/MM/DD");

            filterSearch = { startDate: start, endDate: end };
            this.reportService.getSpRquestedCountReport(filterSearch).subscribe( (result)=> {
                if (result) {
                    const linkSource = 'data:application/vnd.openxmlformats - officedocument.spreadsheetml.sheet;base64, ' + result;
                    const downloadLink = document.createElement('a');
                    const fileName = 'Home-Connect SP Requested Count Report.xls';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
            });
        }
        }


    }



